
export const UserType = {
    ApplicationUser: 1,
    ActiveDirectoryUser: 2,
    ApiUser: 3,
    WsUser: 4
} as const;

export type UserType = typeof UserType[keyof typeof UserType];

export const UserTypes: [UserType, string][] = [
    [UserType.ApplicationUser, 'APP User'],
    [UserType.ActiveDirectoryUser, 'LDAP User'],
    [UserType.ApiUser, 'API User'],
    [UserType.WsUser, 'WS User']
]

export const getUserTypeName = (type: UserType | undefined) => {
    return type !== undefined ? UserTypes.find(([key]) => key === type)?.[1] : undefined
};